import { useDispatch } from "react-redux";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GEO_API } from "@bridgesplit/utils";

const GEO_TAG = "Geo";

export interface GeoResponse {
    accuracy: number;
    country_code: string;
    country_code_3: string;
    country: string;
}
export const geoApi = createApi({
    reducerPath: "geoApi",
    tagTypes: [GEO_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: GEO_API }),
    endpoints: (builder) => ({
        userCountry: builder.query<GeoResponse, undefined>({
            query: () => ({
                url: "geo.json",
                method: "GET"
            })
        })
    })
});

export const { useUserCountryQuery } = geoApi;

export function useGeoApi() {
    const dispatch = useDispatch();
    return { resetGeoApi: () => dispatch(geoApi.util.invalidateTags([GEO_TAG])) };
}
